import { forwardRef } from 'react'
import BaseInput, {
  InputProps as BaseInputProps,
  InputRef,
} from 'antd/lib/input/Input'

export interface InputProps extends BaseInputProps {}

export const Input = forwardRef<InputRef, InputProps>(
  (props, ref): JSX.Element => (
    <>
      <BaseInput ref={ref} {...props} />
    </>
  )
)
